import { StyledButtonContainer } from '@Components/NavigationContentDrawer/SmartBrowserFormModal/SmartBrowserFormModal.common';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';

import TextInput from '../../Common/TextInput';
import { ModalWrapper } from '../ModalWrapper';
import { usePasswordChangeModalPresenter } from './ChangePasswordPresenter';

const Wrapper = styled.View`
  display: flex;
  min-height: 300px;
  justify-content: space-between;
`;

const Section = styled.View`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
`;

export const ChangePasswordModal = observer(function ChangePasswordModal() {
  const { visible, hide, password, passwordConfirm, updateUserPassword } =
    usePasswordChangeModalPresenter();

  return (
    <ModalWrapper visible={visible.value} onDismiss={hide} onClose={hide}>
      <Wrapper>
        <Section>
          <Text style={styles.header}>Change Password</Text>
        </Section>
        <Section>
          <TextInput
            gutterBottom={25}
            fontSizePx={20}
            placeholder='Password'
            value={password.value}
            bgColor='mercury'
            onChange={(text) => {
              password.set(text);
            }}
            textAlign='center'
            secureTextEntry
            color={OwnableTheme.colors.black}
            placeholderColor={OwnableTheme.colors.gray}
          />
          <TextInput
            gutterBottom={16}
            secureTextEntry
            fontSizePx={20}
            placeholder='Confirm Password'
            value={passwordConfirm.value}
            bgColor='mercury'
            onChange={(text) => {
              passwordConfirm.set(text);
            }}
            textAlign='center'
            placeholderColor={OwnableTheme.colors.gray}
            color={OwnableTheme.colors.black}
          />

          <TouchableOpacity onPress={updateUserPassword}>
            <StyledButtonContainer>
              <Text style={styles.buttonText}>Change</Text>
            </StyledButtonContainer>
          </TouchableOpacity>
        </Section>
      </Wrapper>
    </ModalWrapper>
  );
});

const styles = StyleSheet.create({
  button: { marginTop: 20 },
  buttonText: {
    color: OwnableTheme.colors.white,
    fontSize: 20,
  },
  header: {
    fontFamily: OwnableTheme.fonts.gilroy.bold,
    color: OwnableTheme.colors.black,
    fontSize: 24,
    textAlign: 'center',
  },
});
